import React, { useState } from 'react';
import { compose } from 'redux';

import Form from '../MainForm';
import InputText from '../InputText';
import Select from '../Select';
import { Row, ThreeRows, TwoRows } from '../../Structure';
import {
  withApplicantActions,
  withScreenActions,
} from '../../../hocs/withActions';
import { withApplicantData } from '../../../hocs/withData';
import { dayOfMonth, Months, Years } from '../../../helpers/numberOperations';

const ApplicantDetailsForm = ({
  ApplicantData = {},
  SaveApplicantForm = () => {},
  EnableSpinner = () => {},
}) => {
  const [values, setValues] = useState(ApplicantData);

  const handleSubmit = (event) => {
    event.preventDefault();
    EnableSpinner();
    SaveApplicantForm(values);
  };

  const updateField = (event) => {
    const { name, value } = event;
    setValues({ ...values, [name]: value });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <TwoRows>
        <InputText
          name="forename"
          labelTitle="Forename*"
          placeholder="Type your forename here"
          required
          value={values.forename}
          onChange={updateField}
        />
        <InputText
          name="surname"
          labelTitle="Surname*"
          placeholder="Type your surname here"
          required
          value={values.surname}
          onChange={updateField}
        />
      </TwoRows>
      <ThreeRows className="not-full">
        <Select
          labelTitle="Date of Birth*"
          name="day"
          options={dayOfMonth}
          required
          value={values.day}
          onChange={updateField}
        />
        <Select
          name="month"
          options={Months}
          required
          value={values.month}
          onChange={updateField}
        />
        <Select
          name="year"
          options={Years}
          required
          value={values.year}
          onChange={updateField}
        />
      </ThreeRows>
      <Row>
        <InputText
          name="email"
          labelTitle="Email*"
          placeholder="Type your email here"
          type="email"
          required
          value={values.email}
          onChange={updateField}
        />
      </Row>
      <Row className="not-full">
        <InputText
          name="phoneNumber"
          labelTitle="Telephone Number*"
          placeholder="Type your phone number here"
          type="tel"
          pattern="^[0-9-+\s()]*$"
          required
          value={values.phoneNumber}
          onChange={updateField}
        />
      </Row>
      <Row className="not-full">
        <InputText
          labelTitle="National Insurance No.*"
          name="nin"
          onChange={updateField}
          pattern="[a-zA-Z]{2}[0-9]{6}[a-zA-Z]{1}"
          placeholder="Type your National Insurance here"
          required
          value={values.nin}
        />
      </Row>
      <Row>
        <InputText
          name="cpcsCardNumber"
          labelTitle="NOCN/CPCS Number*"
          placeholder="Type your NOCN/CPCS number here"
          required
          type="number"
          value={values.cpcsCardNumber}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="addressLine1"
          labelTitle="Address Line 1*"
          required
          value={values.addressLine1}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="addressLine2"
          labelTitle="Address Line 2*"
          required
          value={values.addressLine2}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="addressLine3"
          labelTitle="Address Line 3*"
          required
          value={values.addressLine3}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="addressLine4"
          labelTitle="Address Line 4"
          value={values.addressLine4}
          onChange={updateField}
        />
      </Row>
      <Row>
        <InputText
          name="homePostcode"
          labelTitle="Postcode*"
          required
          value={values.homePostcode}
          onChange={updateField}
        />
      </Row>
    </Form>
  );
};

export default compose(
  withApplicantData,
  withApplicantActions,
  withScreenActions
)(ApplicantDetailsForm);
